import cn from 'classnames';
import styles from './ModalBody.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * {@link ModalBody} applies a bit of styling for children to comfortably fit into a Modal element.
 */
export function ModalBody({ children, className }: Props) {
  return <div className={cn(styles.ModalBody, className)}>{children}</div>;
}
